import React, { Dispatch, SetStateAction } from 'react'
import { RTORangeSlider } from '../common/range-slider/RTORangeSlider'
import FloCheckbox from '../common/form-elements/FloCheckbox'
import Sparkle from 'public/images/sparkle.svg'

export default function RTORiskContent({
  riskValuesRef,
  sendTags,
  setSendTags,
  suggestedRanges
}: {
  riskValuesRef: React.MutableRefObject<number[]>
  sendTags: boolean
  setSendTags: Dispatch<SetStateAction<boolean>>
  suggestedRanges: { min: number; max: number }
}) {
  return (
    <div className='max-w-[750px]'>
      <div className='flex w-full space-x-2 border-2 border-yellow-lighter rounded-lg p-3 mb-3'>
        <div>
          <div className='w-[30px] h-[30px] bg-[#F9F5E9] rounded-full flex items-center justify-center'>
            <Sparkle className='w-5 h-5 text-yellow-light' id='sparkle-icon' />
          </div>
        </div>
        <div>
          <h3 className='text-md font-medium mb-1'>How do we evaluate the RTO risk?</h3>
          <p className='text-xs leading-[18px] font-normal text-coal-light line'>
            RTO risk of an order is powered by Shopflo's ML model which takes into consideration more than 41 parameters
            (like order details, user's past behaviour, address quality, etc.)
          </p>
        </div>
      </div>
      <div className='border-1 border-gray-light rounded-lg p-3 w-full pb-8 mb-5'>
        <h3 className='text-md font-medium mb-1'>Set RTO risk threshold</h3>
        <p className='text-xs font-normal text-coal-light'>Orders table will show the risk values that are set here</p>
        <div className='mt-3'>
          <div className='flex items-center justify-end'>
            <div className='mb-3 flex justify-between items-center max-w-[270px] border-1 border-gray-light rounded-lg py-2 px-4 space-x-2'>
              <div className='text-xxs font-medium text-coal-dark border-l border-dashed border-gray-dark pl-1'>
                RECOMMENDED VALUE
              </div>
              {/* Bg Colors not present in theme and not used anywhere else not adding them in theme since these are tooo light versions to use elsewhere */}
              <div className='text-xxs font-medium text-coal-dark border-l border-green-dark pl-1 bg-[#EEF5F0]'>
                LOW RISK
              </div>
              <div className='text-xxs font-medium text-coal-dark border-l border-yellow-dark pl-1 bg-[#FBF8F1]'>
                MEDIUM RISK
              </div>
              <div className='text-xxs font-medium text-coal-dark border-l border-red-dark pl-1 bg-[#FBF7F7]'>
                HIGH RISK
              </div>
            </div>
          </div>
          <RTORangeSlider
            initialValues={[0, riskValuesRef.current[0], riskValuesRef.current[1], 100]}
            handleChange={values => {
              riskValuesRef.current = [values[1], values[2]] as number[]
            }}
            suggestedRanges={suggestedRanges}
          />
        </div>
      </div>
      <div className='flex items-start border-1 border-gray-light rounded-lg p-3 w-full pb-8'>
        <div>
          <FloCheckbox value={sendTags} setValue={() => setSendTags(prev => !prev)} />
        </div>
        <div>
          <h3 className='text-md font-medium mb-1'>Send tags to shopify with RTO scores</h3>
          <p className='text-xs font-normal text-coal-light'>
            If you update the risk values, it will show up in future order tags on Shopify. Previously sent tags will
            not get updated according to the new values.¯
          </p>
        </div>
      </div>
    </div>
  )
}
